import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/commerce-php/commerce-php/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h3 {...{
      "id": "ee-244-245-class"
    }}>{`Class changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogInventory\\Model\\Source\\Stock::`}{`_`}{`_`}{`construct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[public]`}{` Method has been added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Ui\\DataProvider\\Product\\Form\\Modifier\\CustomOptions::formatPrice`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Ui\\DataProvider\\Product\\Form\\Modifier\\Eav::formatPrice`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Ui\\DataProvider\\Product\\Form\\Modifier\\General::formatPrice`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`[protected]`}{` Method has been removed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GoogleGtag\\Block\\Ga`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GoogleTagManager\\Block\\Adminhtml\\Creditmemo\\GtagGa`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GoogleTagManager\\Block\\Adminhtml\\GtagGa`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GoogleTagManager\\Block\\GtagGa`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GoogleTagManager\\Model\\Config\\Source\\GtagAccountType`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ee-244-245-database"
    }}>{`Database changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog_product_index_price_tmp/PRIMARY`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Primary key was changed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`catalog_product_index_price_tmp/id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Column was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`customer_eav_attribute/grid_filter_condition_type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Column was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`magento_catalogpermissions_index_product/PRIMARY`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Primary key was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`magento_catalogpermissions_index_product/index_id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Column was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`magento_catalogpermissions_index_product_replica/PRIMARY`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Primary key was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`magento_catalogpermissions_index_product_replica/index_id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Column was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`salesrule_label/SALESRULE_LABEL_ROW_ID_SALESRULE_ROW_ID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Foreign key was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`salesrule_label/SALESRULE_LABEL_ROW_ID_STORE_ID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Unique key was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`salesrule_label/SALESRULE_LABEL_RULE_ID_SEQUENCE_SALESRULE_SEQUENCE_VALUE`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Foreign key was removed`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`salesrule_label/SALESRULE_LABEL_RULE_ID_STORE_ID`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Unique key was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`salesrule_label/row_id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Column was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`salesrule_label/rule_id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Column was added`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ee-244-245-system"
    }}>{`System changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/adwords`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/adwords/active`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/adwords/conversion_id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/adwords/conversion_label`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/analytics4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/analytics4/active`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/analytics4/catalog_page_list_value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/analytics4/container_id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/analytics4/crosssell_block_list_value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/analytics4/experiments`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/analytics4/measurement_id`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/analytics4/promotions_list_value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/analytics4/related_block_list_value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/analytics4/search_page_list_value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/analytics4/type`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`google/gtag/analytics4/upsell_block_list_value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`recaptcha_frontend`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A section-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`recaptcha_frontend/type_for`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`recaptcha_frontend/type_for/customer_invite_create`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`recaptcha_frontend/type_for/giftcard`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`recaptcha_frontend/type_for/wishlist`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`web_api`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A section-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`web_api/graphql`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`web_api/graphql/include_dynamic_attributes_as_entity_type_fields`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/graphql_session`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A group-node was added`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`webapi/graphql_session/disabled`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A field-node was added`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ee-244-245-class-api-membership"
    }}>{`Class API membership changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Analytics\\ReportXml\\DB\\SelectBuilder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogGraphQl\\Model\\Resolver\\Products\\SearchResult`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Block\\Adminhtml\\Product\\Edit\\Button\\Generic`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Block\\Product\\ImageFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Controller\\Adminhtml\\Product`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Config`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Layer\\Filter\\Item`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Layer\\Resolver`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Type\\Price\\Factory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\ResourceModel\\Product\\Indexer\\Price\\IndexTableStructure`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Pricing\\Price\\FinalPrice`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Checkout\\Api\\Exception\\PaymentProcessingRateLimitExceededException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Checkout\\Controller\\Cart`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Checkout\\Model\\Type\\Onepage`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Cms\\Model\\Template\\FilterProvider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Config\\Block\\System\\Config\\Form\\Field\\Factory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Config\\Block\\System\\Config\\Form\\Fieldset\\Factory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Block\\Adminhtml\\Edit\\GenericButton`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Controller\\Adminhtml\\Index`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Controller\\RegistryConstants`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\Context`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\CustomerRegistry`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\Metadata\\FormFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\Url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Setup\\CustomerSetup`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Deploy\\Package\\Package`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Deploy\\Package\\PackageFile`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\Model\\Adapter\\FieldMapper\\Product\\AttributeAdapter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\AclFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Acl\\AclResourceFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Amqp\\ConfigFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\AbstractSimpleObject`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\ExtensionAttribute\\JoinData`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\ExtensionAttribute\\JoinDataInterfaceFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\SearchCriteriaBuilder`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\Search\\DocumentFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\Search\\SearchCriteriaFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Area`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Cache\\Type\\Config`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\ValueFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Filesystem\\DirectoryList`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Http\\Context`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Request\\Http`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Request\\InvalidRequestException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Response\\Http`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Response\\Http\\FileFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Config\\Data\\ConfigDataFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Config\\ViewFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Console\\Cli`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Controller\\Result\\Forward`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Controller\\Result\\JsonFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Controller\\Result\\Raw`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Convert\\DataObject`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Adapter\\Pdo\\MysqlFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Ddl\\TriggerFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Helper`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Helper\\AbstractHelper`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Transaction`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\Factory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\FormFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\Form\\Element\\Factory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\Form\\Element\\Image`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\TreeFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\Tree\\Dbp`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\Tree\\NodeFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\EventFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Event\\ObserverFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\File\\Csv`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\File\\UploaderFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filesystem\\DirectoryList`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filesystem\\Directory\\ReadFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filesystem\\Io\\File`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Config\\Element\\Field`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Exception\\GraphQlAuthenticationException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Exception\\GraphQlAuthorizationException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Exception\\GraphQlInputException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Exception\\GraphQlNoSuchEntityException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\BatchResponse`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\Value`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Schema`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Schema\\Type\\ResolveInfo`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\Adapter\\Curl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\AsyncClient\\Request`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\AsyncClient\\Response`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\Client\\Curl`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\PhpEnvironment\\RemoteAddress`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\PhpEnvironment\\Request`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Image\\AdapterFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Image\\Adapter\\AbstractAdapter`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Logger\\Handler\\Base`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mail\\Address`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mail\\TransportInterfaceFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Message\\CollectionFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Module\\Dir`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Module\\Manager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Module\\Setup\\MigrationFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Profiler\\Driver\\Standard\\Stat`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Session\\Config`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Session\\SessionManager`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Db\\StatementAggregator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Diff\\DiffFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Dto\\Schema`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Dto\\Table`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\ElementHistory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Url`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\UrlFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Url\\Helper\\Data`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ValidatorFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\FileFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\File\\FallbackContextFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\Html\\Select`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\DataProvider\\DataProvider`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\DataProvider\\SearchResult`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Helper\\SecureHtmlRender\\EventHandlerData`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Helper\\SecureHtmlRender\\TagData`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\LayoutFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Layout\\Generator\\ContextFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Layout\\Reader\\ContextFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\PageLayout\\Config`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Page\\ConfigFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Webapi\\Exception`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Webapi\\Rest\\Request`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GiftCardAccount\\Api\\Exception\\TooManyAttemptsException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Export\\Factory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Indexer\\Model\\DimensionModes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Payment\\Gateway\\Config\\Config`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Paypal\\Model\\Billing\\AbstractAgreement`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Cart\\Data\\CartItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Quote\\Address\\RateCollectorInterfaceFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Quote\\Item\\CartItemOptionsProcessor`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Quote\\Item\\Option`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Setup\\QuoteSetup`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Api\\Exception\\CodeRequestLimitException`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Model\\Validator`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Controller\\Adminhtml\\Order`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\CreditmemoFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Email\\Sender\\InvoiceSender`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Email\\Sender\\OrderSender`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Pdf\\Total\\DefaultTotal`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\ResourceModel\\Order\\CollectionFactory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\ResourceModel\\Order\\Collection\\Factory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Service\\InvoiceService`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Setup\\SalesSetup`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ScheduledImportExport\\Model\\Scheduled\\Operation`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Ui\\Component\\Listing\\Column\\Store\\Options`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\TargetRule\\Block\\Product\\AbstractProduct`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\Component\\Control\\Container`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\Component\\Form\\Fieldset\\Factory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\VisualMerchandiser\\Model\\Rules\\Factory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\VisualMerchandiser\\Model\\Sorting\\Factory`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Wishlist\\Model\\Wishlist\\Data\\WishlistItem`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Class was added.`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "ee-244-245-interface-api-membership"
    }}>{`Interface API membership changes`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`What changed`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`How it changed`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdvancedCheckout\\Model\\AreProductsSalableForRequestedQtyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdvancedRule\\Model\\Condition\\FilterGroupInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdvancedRule\\Model\\Condition\\FilterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdvancedRule\\Model\\Condition\\FilterTextGeneratorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdvancedRule\\Model\\Condition\\FilterableConditionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\AdvancedSearch\\Block\\SearchDataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Analytics\\Api\\Data\\LinkInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Analytics\\Api\\LinkProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Analytics\\Model\\Connector\\CommandInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Analytics\\Model\\ExportDataHandlerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Analytics\\Model\\ReportWriterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Analytics\\ReportXml\\DB\\Assembler\\AssemblerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Backend\\Model\\Image\\UploadResizeConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Backend\\Model\\Search\\Config\\Structure\\ElementBuilderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Bundle\\Pricing\\Adjustment\\BundleCalculatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CardinalCommerce\\Model\\Response\\JwtParserInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CardinalCommerce\\Model\\Response\\JwtPayloadValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogGraphQl\\DataProvider\\Product\\LayeredNavigation\\LayerBuilderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogGraphQl\\Model\\Resolver\\Categories\\DataProvider\\Category\\CollectionProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogGraphQl\\Model\\Resolver\\Product\\Price\\ProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogGraphQl\\Model\\Resolver\\Products\\DataProvider\\Product\\CollectionProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogGraphQl\\Model\\Resolver\\Products\\Query\\ProductQueryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogImportExport\\Model\\Export\\ProductFilterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogRule\\Model\\Indexer\\IndexerTableSwapperInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogSearch\\Model\\Adapter\\Aggregation\\RequestCheckerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogSearch\\Model\\Advanced\\ProductCollectionPrepareStrategyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogSearch\\Model\\ResourceModel\\Fulltext\\Collection\\SearchCriteriaResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogSearch\\Model\\ResourceModel\\Fulltext\\Collection\\SearchResultApplierInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogSearch\\Model\\ResourceModel\\Fulltext\\Collection\\TotalRecordsResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogSearch\\Model\\Search\\ItemCollectionProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogUrlRewrite\\Model\\Map\\DatabaseMapInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CatalogUrlRewrite\\Model\\Map\\HashMapInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Block\\Product\\AwareInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Block\\Product\\ReviewRendererInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Controller\\Adminhtml\\Product\\Initialization\\Helper\\HandlerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Controller\\Product\\View\\ViewInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Attribute\\LockValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Config\\Source\\ProductPriceOptionsInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Entity\\Product\\Attribute\\Group\\AttributeMapperInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Indexer\\Product\\Flat\\TableDataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Layer\\CollectionFilterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Layer\\FilterableAttributeListInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Layer\\ItemCollectionProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Layer\\StateKeyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\ProductLink\\CollectionProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\ProductLink\\Converter\\ConverterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\ProductLink\\Data\\ListCriteriaInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\ProductLink\\Data\\ListResultInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\ProductLink\\MapProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\ProductOptions\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Condition\\ConditionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Configuration\\Item\\Option\\OptionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Media\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\Product\\Pricing\\Renderer\\SalableResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\ResourceModel\\Product\\Indexer\\Price\\PriceModifierInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Model\\ResourceModel\\Product\\LinkedProductSelectBuilderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Pricing\\Price\\ConfiguredPriceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Pricing\\Price\\MinimalPriceCalculatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Pricing\\Price\\SpecialPriceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Catalog\\Ui\\DataProvider\\Product\\Form\\Modifier\\Eav\\WysiwygConfigDataProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CheckoutAgreements\\Model\\AgreementsProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Checkout\\Api\\PaymentProcessingRateLimiterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Checkout\\Controller\\Express\\RedirectLoginInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Checkout\\CustomerData\\ItemPoolInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Cms\\Model\\PageRepository\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Cms\\Model\\Page\\CustomLayoutManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Cms\\Model\\Page\\CustomLayoutRepositoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Cms\\Model\\Page\\CustomLayout\\Data\\CustomLayoutSelectedInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Cms\\Ui\\Component\\AddFilterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ConfigurableProduct\\Model\\ResourceModel\\Attribute\\OptionSelectBuilderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Cron\\Model\\DeadlockRetrierInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Csp\\Api\\CspAwareActionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Csp\\Api\\CspRendererInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Csp\\Api\\Data\\ModeConfiguredInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Csp\\Api\\Data\\PolicyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Csp\\Api\\InlineUtilInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Csp\\Api\\ModeConfigManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Csp\\Api\\PolicyCollectorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Csp\\Api\\PolicyRendererInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Csp\\Model\\Collector\\Config\\PolicyReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Csp\\Model\\Collector\\MergerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Csp\\Model\\Policy\\SimplePolicyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\CustomerCustomAttributes\\Model\\Customer\\Attribute\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Api\\AccountDelegationInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Api\\SessionCleanerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Block\\Address\\Renderer\\RendererInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Controller\\AccountInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\CustomerData\\JsLayoutDataProviderPoolInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\CustomerData\\SectionPoolInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Customer\\Model\\Customer\\Attribute\\Source\\GroupSourceLoggedInOnlyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Deploy\\Collector\\CollectorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Deploy\\Console\\Command\\App\\SensitiveConfigSet\\CollectorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Deploy\\Package\\BundleInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Deploy\\Package\\Processor\\ProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Deploy\\Source\\SourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Deploy\\Strategy\\StrategyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Directory\\Model\\Country\\Postcode\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Directory\\Model\\Country\\Postcode\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Downloadable\\Api\\DomainManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Downloadable\\Pricing\\Price\\LinkPriceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Entity\\AttributeLoaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Entity\\Attribute\\AttributeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Entity\\Attribute\\Backend\\BackendInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Entity\\Attribute\\Source\\SpecificSourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Entity\\Attribute\\UniqueValidationInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\Entity\\Setup\\PropertyMapperInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Eav\\Model\\ResourceModel\\Attribute\\DefaultEntityAttributes\\ProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\Model\\Adapter\\FieldMapper\\Product\\FieldProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\Model\\Adapter\\FieldMapper\\Product\\FieldProvider\\FieldIndex\\ConverterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\Model\\Adapter\\FieldMapper\\Product\\FieldProvider\\FieldIndex\\ResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\Model\\Adapter\\FieldMapper\\Product\\FieldProvider\\FieldName\\ResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\Model\\Adapter\\FieldMapper\\Product\\FieldProvider\\FieldType\\ResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\Model\\Adapter\\FieldsMappingPreprocessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\SearchAdapter\\QueryAwareInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Elasticsearch\\SearchAdapter\\Query\\ValueTransformerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Amqp\\Topology\\BindingInstallerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\AttributeTypeResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\CriteriaInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\SearchCriteria\\CollectionProcessor\\ConditionProcessor\\CustomConditionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\SearchCriteria\\CollectionProcessor\\ConditionProcessor\\CustomConditionProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\Search\\AggregationInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\Search\\AggregationValueInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\Search\\BucketInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\Search\\DocumentInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\Search\\ReportingInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Api\\SimpleBuilderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Action\\HttpConnectActionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Action\\HttpDeleteActionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Action\\HttpGetActionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Action\\HttpOptionsActionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Action\\HttpPatchActionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Action\\HttpPostActionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Action\\HttpPropfindActionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Action\\HttpPutActionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Action\\HttpTraceActionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\AreaInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\CommentInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\CommentParserInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\ConfigResource\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\ConfigSourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\ConfigTypeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\Reader\\Source\\SourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\Scope\\ReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\Spi\\PostProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\Spi\\PreProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Config\\ValueInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\CsrfAwareActionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\DefaultPathInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\DeploymentConfig\\ImporterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\DeploymentConfig\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\DeploymentConfig\\Writer\\FormatterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\DesignInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\EnvironmentInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\ExceptionHandlerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\FeedFactoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\FeedInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\HttpRequestInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\ObjectManager\\ConfigWriterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\PageCache\\NotCacheableInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Request\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\ResourceConnection\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\ResourceConnection\\ConnectionAdapterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Response\\FileInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Response\\HeaderProvider\\HeaderProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Response\\RedirectInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\RouterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\RouterListInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Router\\NoRouteHandlerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Router\\PathConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Rss\\RssManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Rss\\UrlBuilderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\ScopeFallbackResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\ScopeResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\ScopeTreeProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\ScopeValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\Scope\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\View\\Asset\\MaterializationStrategy\\StrategyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\App\\View\\Deployment\\Version\\StorageInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Async\\CancelableDeferredInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Async\\DeferredInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Autoload\\AutoloaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Backup\\SourceFileInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Cache\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Cache\\StaleCacheNotifierInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Code\\Generator\\CodeGeneratorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Code\\Minifier\\AdapterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Code\\Reader\\ClassReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Code\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Component\\ComponentRegistrarInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Crontab\\CrontabManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Crontab\\TasksProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Css\\PreProcessor\\ErrorHandlerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\DataConverter\\DataConverterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\LoggerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\MapperInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\QueryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Query\\BatchIteratorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Select\\QueryModifierInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Select\\RendererInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Sequence\\SequenceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DB\\Sql\\ExpressionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\IdentityGeneratorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\IdentityInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\IdentityValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\DataObject\\KeyValueObjectInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\CollectionDataSourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\CollectionModifierInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\Collection\\Db\\FetchStrategyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\Collection\\EntityFactoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\SearchResultInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\SearchResultProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Data\\ValueSourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Encryption\\Adapter\\EncryptionAdapterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Event\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Event\\InvokerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Event\\ManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Exception\\TemporaryStateExceptionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filesystem\\Directory\\PathValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filesystem\\DriverPoolInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filesystem\\File\\ReadInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filter\\DirectiveProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filter\\DirectiveProcessor\\FilterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filter\\FactoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filter\\FilterManager\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filter\\SimpleDirective\\ProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Filter\\VariableResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ForeignKey\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ForeignKey\\ConstraintInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ForeignKey\\StrategyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQlSchemaStitching\\GraphQlReader\\TypeMetaReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Config\\ConfigElementFactoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Config\\ConfigElementInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Config\\Element\\FieldInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Config\\Element\\OutputFieldInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Config\\Element\\TypeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Config\\Element\\UnionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\ErrorHandlerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\ResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\Argument\\FieldEntityAttributesInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\Argument\\SearchCriteria\\ArgumentApplierInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\BatchRequestItemInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\BatchResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\BatchServiceContractResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\ContextInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\IdentityInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\ResolveRequestInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Query\\Resolver\\TypeResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Schema\\SchemaGeneratorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Schema\\TypeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Schema\\Type\\Entity\\MapperInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Schema\\Type\\Enum\\DataMapperInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Schema\\Type\\InputTypeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Schema\\Type\\OutputTypeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Schema\\Type\\Output\\ElementMapper\\FormatterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\GraphQl\\Schema\\Type\\WrappedTypeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\AsyncClientInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\HTTP\\AsyncClient\\HttpResponseDeferredInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Image\\Adapter\\AdapterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Image\\Adapter\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Indexer\\Config\\DependencyInfoProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Indexer\\Table\\StrategyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Interception\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Interception\\ConfigLoaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Interception\\ConfigWriterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Interception\\DefinitionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Interception\\InterceptorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Interception\\ObjectManager\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Interception\\PluginListInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Locale\\AvailableLocalesInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Locale\\OptionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mail\\EmailMessageInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mail\\MimeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mail\\MimeMessageInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mail\\MimePartInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\BulkPublisherInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\CallbackInvokerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\ConnectionTypeResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\ConsumerConfigurationInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Consumer\\Config\\ConsumerConfigItemInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Consumer\\Config\\ConsumerConfigItem\\HandlerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Consumer\\Config\\ReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Consumer\\Config\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\LockInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Lock\\ReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Lock\\WriterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\MergedMessageInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\MergerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\MessageProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\PoisonPill\\PoisonPillCompareInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\PoisonPill\\PoisonPillPutInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\PoisonPill\\PoisonPillReadInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Publisher\\Config\\PublisherConfigItemInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Publisher\\Config\\PublisherConnectionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Publisher\\Config\\ReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Publisher\\Config\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Topology\\Config\\ExchangeConfigItemInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Topology\\Config\\ExchangeConfigItem\\BindingInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Topology\\Config\\QueueConfigItemInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Topology\\Config\\ReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\MessageQueue\\Topology\\Config\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Message\\ExceptionMessageFactoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Model\\EntitySnapshot\\AttributeProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Model\\Entity\\ScopeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Model\\Entity\\ScopeProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Model\\ResourceModel\\Db\\VersionControl\\RelationInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Model\\ResourceModel\\Type\\Db\\ConnectionFactoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Module\\ModuleListInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mview\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mview\\ProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mview\\ViewInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mview\\View\\ChangelogInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mview\\View\\CollectionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mview\\View\\StateInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mview\\View\\State\\CollectionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Mview\\View\\SubscriptionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ObjectManager\\ConfigCacheInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ObjectManager\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ObjectManager\\ConfigLoaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ObjectManager\\DefinitionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ObjectManager\\DynamicConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ObjectManager\\FactoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ObjectManager\\NoninterceptableInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\ObjectManager\\RelationsInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Profiler\\Driver\\Standard\\OutputInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\AdapterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\Adapter\\Aggregation\\AggregationResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\Adapter\\OptionsInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\Adapter\\Preprocessor\\PreprocessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\Dynamic\\Algorithm\\AlgorithmInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\Request\\Aggregation\\StatusInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\Request\\IndexScopeResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\ResponseInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\SearchEngineInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Search\\SearchEngine\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Session\\Config\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Session\\SaveHandlerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Session\\StorageInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Session\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\ConfigOptionsListInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\DataCacheInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\DataSavior\\DataSaviorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\DataSavior\\DumpAccessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Db\\DDLTriggerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Db\\DbDefinitionProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Db\\DbSchemaReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Db\\DbSchemaWriterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Declaration\\ValidationInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Diff\\DiffInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Dto\\Columns\\ColumnDefaultAwareInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Dto\\Columns\\ColumnIdentityAwareInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Dto\\Columns\\ColumnNullableAwareInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Dto\\Columns\\ColumnUnsignedAwareInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Dto\\ElementDiffAwareInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Dto\\Factories\\FactoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\Dto\\TableElementInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\OperationInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Declaration\\Schema\\SchemaConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Patch\\DataPatchInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Patch\\DependentPatchInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Patch\\NonTransactionableInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Patch\\PatchInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Patch\\PatchRevertableInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\Patch\\SchemaPatchInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\SampleData\\InstallerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\SampleData\\StateInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\SchemaListenerDefinition\\DefinitionConverterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\SchemaListenerHandlers\\SchemaListenerHandlerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Setup\\UpToDateValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\TestFramework\\Unit\\Autoloader\\GeneratorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\TranslateInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Translate\\Inline\\ProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Url\\ModifierInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Url\\RouteParamsPreprocessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\Constraint\\OptionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\HTML\\AttributeValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\HTML\\TagValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Validator\\HTML\\WYSIWYGValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\ContentProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\ContextInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\LockerProcessInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\MergeStrategyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\MergeableInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Asset\\PreProcessor\\FilenameResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\DesignInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Design\\Fallback\\Rule\\RuleInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Design\\FileResolution\\Fallback\\ResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Design\\Theme\\CustomizationInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Design\\Theme\\Customization\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Design\\Theme\\Customization\\FileAssetInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Design\\Theme\\Customization\\FileInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Design\\Theme\\FileInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Design\\Theme\\File\\CollectionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Design\\Theme\\Image\\PathInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Design\\Theme\\ResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Design\\Theme\\ThemeProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\ComponentVisibilityInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\Message\\InterpretationStrategyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\Message\\Renderer\\PoolInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\Message\\Renderer\\RendererInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\BlockWrapperInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\Config\\DomMergerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\Config\\FileCollectorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\Config\\UiReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\ContainerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\ContentType\\ContentTypeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\ContextInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\Control\\ActionPoolInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\Control\\ButtonProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\Control\\ControlInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\DataProvider\\FilterApplierInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\DataSourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\Factory\\ComponentFactoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\JsConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\LayoutInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\ObserverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\PoolInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Element\\UiComponent\\SubjectInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\File\\FileList\\CollateInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Helper\\SecureHtmlRender\\SecurityProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Layout\\Argument\\UpdaterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Layout\\Condition\\VisibilityConditionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Layout\\GeneratorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Layout\\LayoutCacheKeyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Layout\\ProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Layout\\ReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Model\\PageLayout\\Config\\BuilderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Page\\Config\\RendererInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\TemplateEngineInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\TemplateEngine\\Xhtml\\Compiler\\AttributeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\TemplateEngine\\Xhtml\\Compiler\\CdataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\TemplateEngine\\Xhtml\\Compiler\\CommentInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\TemplateEngine\\Xhtml\\Compiler\\Directive\\DirectiveInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\TemplateEngine\\Xhtml\\Compiler\\Element\\ElementInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\TemplateEngine\\Xhtml\\Compiler\\TextInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\TemplateEngine\\Xhtml\\ResultInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\View\\Xsd\\Media\\TypeDataExtractorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Webapi\\CustomAttributeTypeLocatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Webapi\\CustomAttribute\\PreprocessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Webapi\\CustomAttribute\\ServiceTypeListInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Framework\\Webapi\\Rest\\Request\\DeserializerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GiftCardAccount\\Api\\GiftCardRedeemerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GiftCardAccount\\Model\\Spi\\Data\\UsageAttemptInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GiftCardAccount\\Model\\Spi\\GiftCardAccountManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GiftCardAccount\\Model\\Spi\\GiftCardAccountResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GiftCardAccount\\Model\\Spi\\UsageAttemptFactoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GiftCardAccount\\Model\\Spi\\UsageAttemptsManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GiftRegistry\\Model\\Attribute\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GraphQl\\Controller\\HttpHeaderProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GraphQl\\Controller\\HttpRequestValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GraphQl\\Model\\Query\\ContextInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GraphQl\\Model\\Query\\ContextParametersInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\GraphQl\\Model\\Query\\ContextParametersProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Api\\Data\\ExtendedExportInfoInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ImportExport\\Model\\Report\\ReportProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Indexer\\Model\\ModeSwitcherInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Indexer\\Model\\Source\\DataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Integration\\Model\\Oauth\\Token\\RequestLog\\ReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Integration\\Model\\Oauth\\Token\\RequestLog\\WriterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\InventoryIndexer\\Indexer\\SelectBuilderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Invitation\\Controller\\Customer\\AccountInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\LoginAsCustomerApi\\Api\\Data\\IsLoginAsCustomerEnabledForCustomerResultInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\LoginAsCustomerApi\\Api\\GetLoggedAsCustomerAdminIdInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\LoginAsCustomerApi\\Api\\GetLoggedAsCustomerCustomerIdInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\LoginAsCustomerApi\\Api\\IsLoginAsCustomerEnabledForCustomerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\LoginAsCustomerApi\\Api\\SetLoggedAsCustomerAdminIdInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\LoginAsCustomerApi\\Api\\SetLoggedAsCustomerCustomerIdInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\LoginAsCustomerAssistance\\Api\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\LoginAsCustomerAssistance\\Api\\IsAssistanceEnabledInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\LoginAsCustomerAssistance\\Api\\SetAssistanceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaContentApi\\Api\\GetAssetIdsByContentFieldInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaContentApi\\Api\\UpdateContentAssetLinksInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaContentApi\\Model\\GetAssetIdsByContentFieldInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaContentApi\\Model\\SearchPatternConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaContentSynchronizationApi\\Api\\SynchronizeIdentitiesInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaContentSynchronizationApi\\Api\\SynchronizeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaContentSynchronizationApi\\Model\\GetEntitiesInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryApi\\Api\\SearchAssetsInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryApi\\Model\\ExcludedPatternsConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryMetadataApi\\Api\\AddMetadataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryMetadataApi\\Api\\Data\\MetadataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryMetadataApi\\Api\\ExtractMetadataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryMetadataApi\\Model\\FileInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryMetadataApi\\Model\\ReadFileInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryMetadataApi\\Model\\ReadMetadataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryMetadataApi\\Model\\SegmentInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryMetadataApi\\Model\\WriteFileInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryMetadataApi\\Model\\WriteMetadataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryRenditionsApi\\Api\\GenerateRenditionsInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryRenditionsApi\\Api\\GetRenditionPathInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGallerySynchronizationApi\\Api\\SynchronizeFilesInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGallerySynchronizationApi\\Api\\SynchronizeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGallerySynchronizationApi\\Model\\CreateAssetFromFileInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGallerySynchronizationApi\\Model\\FetchBatchesInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGallerySynchronizationApi\\Model\\ImportFilesInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MediaGalleryUiApi\\Api\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Msrp\\Pricing\\MsrpPriceCalculatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MultipleWishlist\\Controller\\IndexInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\MultipleWishlist\\Model\\Search\\Strategy\\StrategyInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Newsletter\\Model\\SubscriptionManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\PageCache\\Model\\Spi\\PageCacheTagsPreprocessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Payment\\Api\\Data\\PaymentAdditionalInfoInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Payment\\Model\\Method\\TransparentInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Paypal\\Helper\\Shortcut\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Paypal\\Model\\Billing\\Agreement\\MethodInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Paypal\\Model\\IpnInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Paypal\\Model\\Payflow\\Service\\Response\\Handler\\HandlerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuoteGraphQl\\Model\\CartItem\\DataProvider\\CustomizableOptionValueInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuoteGraphQl\\Model\\CartItem\\DataProvider\\Processor\\ItemDataProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuoteGraphQl\\Model\\Cart\\BuyRequest\\BuyRequestDataProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuoteGraphQl\\Model\\Cart\\Payment\\AdditionalDataProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuoteGraphQl\\Model\\Cart\\SetShippingAddressesOnCartInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\QuoteGraphQl\\Model\\Cart\\SetShippingMethodsOnCartInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Api\\ChangeQuoteControlInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Cart\\BuyRequest\\BuyRequestDataProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Product\\QuoteItemsCleanerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Quote\\Address\\CustomAttributeListInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Quote\\Address\\Total\\CollectorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Quote\\Address\\Total\\ReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\Quote\\Item\\CartItemProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Quote\\Model\\ValidationRules\\QuoteValidationRuleInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ReleaseNotification\\Model\\ContentProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\RemoteStorage\\Driver\\DriverFactoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\RemoteStorage\\Driver\\RemoteDriverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\RemoteStorage\\FilesystemInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\RewardGraphQl\\Model\\Formatter\\Customer\\FormatterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Reward\\Observer\\PlaceOrder\\RestrictionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Rma\\Model\\Spi\\CommentResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Rma\\Model\\Spi\\RmaResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Rma\\Model\\Spi\\TrackResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesGraphQl\\Model\\Shipment\\Item\\FormatterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Api\\Data\\DiscountDataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Api\\Data\\RuleDiscountInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Model\\Spi\\CodeLimitManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Model\\Spi\\QuoteResetAppliedRulesInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\SalesRule\\Model\\Spi\\RuleQuoteRecollectTotalsInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Api\\OrderCustomerDelegateInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Api\\PaymentFailuresInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Controller\\AbstractController\\OrderLoaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Controller\\AbstractController\\OrderViewAuthorizationInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Controller\\OrderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Creditmemo\\CreditmemoValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Creditmemo\\ItemCreationValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Creditmemo\\SenderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Email\\Container\\IdentityInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Invoice\\InvoiceValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Invoice\\SenderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\OrderValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Payment\\State\\CommandInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Payment\\Transaction\\BuilderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Payment\\Transaction\\ManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Shipment\\SenderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Order\\Shipment\\ShipmentValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\ResourceModel\\Order\\CollectionFactoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\ResourceModel\\Provider\\NotSyncedDataProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\CreditmemoCommentResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\CreditmemoItemResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\CreditmemoResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\InvoiceCommentResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\InvoiceItemResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\InvoiceResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\OrderAddressResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\OrderItemResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\OrderPaymentResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\OrderResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\OrderStatusHistoryResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\ShipmentCommentResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\ShipmentItemResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\ShipmentResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\ShipmentTrackResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\Spi\\TransactionResourceInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Sales\\Model\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\ScheduledImportExport\\Model\\Scheduled\\Operation\\OperationInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Search\\Model\\SearchEngine\\ValidatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Search\\Setup\\InstallConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Security\\Api\\Data\\UserExpirationInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Shipping\\Model\\Carrier\\Source\\GenericInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Block\\Adminhtml\\Update\\Entity\\EntityProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Block\\Adminhtml\\Update\\Entity\\StoreIdProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Model\\Entity\\BuilderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Model\\Entity\\HydratorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Model\\Entity\\PersisterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Model\\Entity\\RemoverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Model\\Entity\\RetrieverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Model\\Entity\\Update\\Action\\TransactionExecutorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Model\\Operation\\Update\\UpdateProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Model\\StagingApplierInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Model\\Update\\Grid\\ActionDataProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Model\\Update\\IncludesInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Model\\VersionHistoryInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Staging\\Ui\\Component\\Listing\\Column\\Entity\\UrlProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\Config\\Importer\\Processor\\ProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\StoreResolver\\ReaderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\StoreSwitcherInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\StoreSwitcher\\ContextInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\StoreSwitcher\\RedirectDataInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\StoreSwitcher\\RedirectDataPostprocessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\StoreSwitcher\\RedirectDataPreprocessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Store\\Model\\StoreSwitcher\\RedirectDataSerializerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Support\\Model\\Report\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Swat\\Api\\Data\\JwtInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Swat\\Api\\Data\\SwatKeyPairInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Tax\\Api\\TaxAddressManagerInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Tax\\Model\\System\\Message\\NotificationInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Tax\\Model\\TaxClass\\Type\\TypeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Theme\\Model\\Design\\Config\\MetadataProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Theme\\Model\\Theme\\StoreThemesResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\Component\\Form\\Element\\DataType\\DataTypeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\Component\\Layout\\Tabs\\TabInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\Component\\Wysiwyg\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\Config\\Argument\\ParserInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\Config\\ConverterInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\Controller\\UiActionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\DataProvider\\AddFieldToCollectionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\DataProvider\\AddFilterToCollectionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\DataProvider\\Mapper\\MapperInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\DataProvider\\Modifier\\PoolInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\Model\\ColorPicker\\ModeInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Ui\\Model\\UrlInput\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\UrlRewriteGraphQl\\Model\\Resolver\\UrlRewrite\\CustomUrlLocatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\User\\Model\\Spi\\NotificationExceptionInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\User\\Model\\Spi\\NotificatorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Vault\\Block\\Customer\\IconInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\VersionsCms\\Model\\CurrentNodeResolverInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\VersionsCms\\Model\\Hierarchy\\ConfigInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\VisualMerchandiser\\Api\\RuleFactoryPoolInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Webapi\\Controller\\Rest\\RequestProcessorInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Widget\\Block\\BlockInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Wishlist\\Controller\\IndexInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Wishlist\\Controller\\WishlistProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Wishlist\\Model\\AuthenticationStateInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Wishlist\\Model\\ResourceModel\\Item\\Product\\CollectionBuilderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Magento\\Wishlist\\Model\\Wishlist\\BuyRequest\\BuyRequestDataProviderInterface`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Interface was added.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      